<template>
  <div>
    <validation-observer
      v-slot="{handleSubmit}"
      ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(formSubmit)">
          <div class="form-row">
            <div class="col-md-12">
              <base-input :label="$t('Choose file')">
                <file-input v-on:change="filesChange"></file-input>
              </base-input>
            </div>
          </div>
        <base-button
          type="primary"
          :loading="loading"
          native-type="submit">
          {{ $t('Send answer') }}
        </base-button>
      </form>
    </validation-observer>
  </div>
</template>


<script>
  import FileInput from "@/components/Inputs/FileInput";

  export default {
    name: "FormTaskAnswerUpload",
    components: {
      FileInput
    },
    data() {
      return {
        file: [],
        loading: false,
        fileReader: new FileReader(),
      }
    },
    computed: {
      dataUrl() {
        return this.fileReader['result'];
      }
    },
    methods: {
      formSubmit() {
        this.$emit('onAnswer', {"upload": this.dataUrl});
      },
      filesChange(file) {
        this.file = file;
        this.fileReader.readAsDataURL(this.file[0]);
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
